import React from 'react';
import Loader from '@pattern-library/loaders';

function SsoLauncher() {
    return (
        <div className="ee-tools-sso-launcher">
            <Loader show />
        </div>
    );
}
export default SsoLauncher;
